
/* injects from baggage-loader */

'use strict';
/*eslint-disable */
import StageBaseController from "../stage-base.controller";

// import $j from 'jquery';

import _ from "lodash";

import { dialogos, briefing } from './main.const';

export default class MainController extends StageBaseController{
	constructor($log, $state, $scope, Session, Dialog, $timeout) {
		'ngInject';

		super($log, $state, Session, Dialog);
		
		this.$scope = $scope;
		// this.$j;
		this.$timeout = $timeout;
		this.Session = Session;
		this.Dialog = Dialog;

		this.infoIlha = false;
		this.dialogs = dialogos;
		this.briefing = briefing;
		this.index = 0;
		this.loaded = false;

		this.islandStyle = {
			style: {
				opacity: 1
			}
		}

		this.stages = "";

		this.montanhaDialog = [
		"A escassez de alimentos tem prejudicado os lados leste e oeste da ilha. Faltam frutas para o lado oeste e não há animais no lado leste.",
		"Os dois povos perceberam que poderiam multiplicar as forças e, assim, dividir dificuldades."
		];
		
	}

	$onInit(){
		let { stages, user, dialogMatemagico, endGame } = this.Session.get();
		let $ctrl = this;
		this.stages = stages;
		this.index = _.findIndex(stages, ['completed', false]);
		this.$log.log(this.index);
		if(this.index<0){
			if(endGame){
				this.index = 99;
				this.clearIsland(1);
			} else {
				this.index = 5;
				if(dialogMatemagico){
					this.$timeout(function(){
						$ctrl.Dialog.showMatemagico($ctrl.dialogs[$ctrl.index], user, $ctrl.tutorial.bind($ctrl, 'm4'));
						$ctrl.loaded = true;
					}, 400);
				}
			}
		} else if(this.index === 0){
			if(dialogMatemagico){
				this.$timeout(function(){
					$ctrl.Dialog.showMatemagico($ctrl.dialogs[$ctrl.index], user, $ctrl.tutorial.bind($ctrl, 'm1',$ctrl.tutorial2.bind($ctrl, 'm2',3)));
					$ctrl.loaded = true;
				}, 400);
			} else {
				this.loaded = true;
			}
		} else if(this.index === 2 || this.index === 4){
			if(dialogMatemagico){
				this.$timeout(function(){
					$ctrl.Dialog.showMatemagico($ctrl.dialogs[$ctrl.index], user);
					$ctrl.loaded = true;
				}, 400);
			} else {
				this.loaded = true;
			}
		}else if(dialogMatemagico){
			this.$timeout(function(){
				$ctrl.Dialog.showMatemagico($ctrl.dialogs[$ctrl.index], user, $ctrl.missionInfo.bind($ctrl));
				$ctrl.loaded = true;
			}, 400);			
		} else {
			this.loaded = true;
		}
	}

	tutorial2(num,i){
		this.exibeInfoIlha(i);
		this.Dialog.showTutorial(num);		
	}

	tutorial(num, callback){
		this.Dialog.showTutorial(num, callback);
	}

	clearIsland(num){
		let $ctrl = this;
		if(num>0){
			this.islandStyle.style.opacity = num;
			this.$timeout(()=>this.clearIsland(num-0.1),400);
		} else {
			this.islandStyle.style.opacity = 0;
			this.$timeout(function(){
				$ctrl.Session.destroy();
				$ctrl.$state.go('login');
			}, 1200);
		}

	}

	missionInfo(){
		if(this.index<5){
			let { items, text } = this.briefing[this.index];
			this.Session.setDialog(true);
			this.Dialog.showMission(text, items, this.goToStage.bind(this, this.index));
		} else {
			this.Session.setDialog(true);
			this.goToStage(this.index);
		}
	}

	exibeInfoIlha(i){
	/**
	 * Define qual imagem de ilha deve ser exibida
	 * 
	 * @param i Info de ilha a ser exibida
	 */
	 if(this.loaded)
	 	this.infoIlha = i;
	 else
	 	return false;
	}

	goToStage(s){
		switch(s){
			case 0:
			this.$state.go("stages.stage-one");
			break;
			case 1:
			this.$state.go("stages.stage-one");
			break;
			case 2:
			this.$state.go("stages.stage-two");
			break;
			case 3:
			this.$state.go("stages.stage-two");
			break;
			case 4:
			this.$state.go("stages.stage-two");
			break;
			case 5:
			this.$state.go("montanha");
			break;
			default:
			this.$state.go("main");
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/pages/main/main.controller.js